import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { expensesApi } from 'src/Services/API';
import { CreateExpenseDto, ExpenseWithSharesDto } from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';

export const useCreateExpense = (
  options?: UseMutationOptions<ExpenseWithSharesDto, unknown, CreateExpenseDto>
) => {
  const assetId = useCurrentAssetId();
  const queryClient = useQueryClient();

  return useMutation<ExpenseWithSharesDto, unknown, CreateExpenseDto>(
    ['create-expense', assetId],
    async expense => {
      if (!assetId) {
        throw new Error('No asset selected');
      }
      const response = await expensesApi.expensesControllerCreate(assetId, expense);
      return response.data;
    },
    {
      ...options,
      onSuccess: (data: ExpenseWithSharesDto, variables: CreateExpenseDto, context: unknown) => {
        trackEvent('Expense', 'create', data.title);

        queryClient.invalidateQueries({ queryKey: ['fetch-expenses'] });
        queryClient.invalidateQueries({ queryKey: ['fetch-expense-stats'] });
        queryClient.invalidateQueries({ queryKey: ['fetch-expense-balance'] });
        queryClient.invalidateQueries({ queryKey: ['fetch-personal-wallet'] });
        if (options?.onSuccess) {
          options.onSuccess(data, variables, context);
        }
      },
    }
  );
};
